/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="100%" height="100%" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="currentColor" stroke="none">
<path d="M4368 5095 c-59 -22 -125 -72 -158 -120 -53 -76 -60 -112 -60 -286 0
-88 -2 -159 -4 -159 -2 0 -54 37 -114 83 -316 237 -684 394 -1082 463 -148 25
-522 31 -685 10 -837 -108 -1549 -619 -1910 -1370 -154 -320 -229 -618 -242
-966 -5 -145 -4 -159 17 -214 28 -73 95 -148 165 -184 72 -37 188 -42 267 -12
79 29 148 94 183 171 24 54 28 80 36 209 16 288 73 508 195 745 284 555 852
929 1464 964 389 22 730 -60 1047 -251 88 -53 242 -166 243 -179 0 -3 -81 -13
-181 -23 -248 -23 -314 -51 -388 -163 -83 -126 -71 -287 31 -399 66 -71 133
-106 218 -111 79 -5 1131 91 1180 108 86 30 155 95 199 189 l26 55 3 555 c2
381 0 575 -8 620 -30 173 -159 281 -333 279 -40 0 -89 -7 -109 -14z"/>
<path d="M4556 2765 c-71 -29 -138 -91 -173 -160 -22 -42 -27 -70 -34 -180
-11 -173 -17 -223 -41 -335 -166 -780 -824 -1353 -1617 -1409 -459 -33 -912
110 -1256 396 l-70 58 236 21 c269 24 313 38 390 116 66 68 94 137 94 233 -1
98 -23 152 -92 226 -55 59 -102 86 -175 99 -76 15 -1159 -83 -1234 -111 -71
-27 -146 -96 -181 -167 l-28 -57 0 -610 c0 -609 0 -610 22 -658 12 -26 47 -73
78 -102 135 -132 342 -123 473 20 66 72 83 123 89 268 3 64 7 117 9 117 2 0
34 -23 71 -51 248 -185 627 -356 930 -419 235 -48 560 -65 791 -39 546 59
1074 317 1467 714 441 446 699 1048 708 1655 l2 145 -33 67 c-80 162 -260 231
-426 163z"/>
</g>
</svg>
`

const RefreshSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default RefreshSvg
